export const isContained = (s: string, substring: string): boolean => {
    return s.toLowerCase().includes(substring.toLowerCase());
}